import { BaseAction } from "../../../core/actions/BaseAction";
import { IBookedOffer } from "../../../Orchestrator/Types/Index";


export class GetAllOfferWithoutExchangeAction extends BaseAction<IBookedOffer[], IBookedOffer[]> {

    override async run(): Promise<IBookedOffer[]> {
        const allBookedOfferWithoutExchange: IBookedOffer[] = []
        try {
            const bookedOffers: IBookedOffer[] = this.params!
            bookedOffers?.forEach((offer: IBookedOffer) => {
                const offerAdmissions = offer.admissions;
                const fulfilledAdmissions = offerAdmissions.filter(d => d.status !== "EXCHANGED")
                if (fulfilledAdmissions.length > 0) {
                    // Create a new offer with only the fulfilled admissions
                    const newOffer = {
                        ...offer,
                        admissions: fulfilledAdmissions
                    }
                    allBookedOfferWithoutExchange.push(newOffer)
                }
            })
        } catch (error: any) {
            console.error("Error fetching Data:", error);
        } finally {
            return allBookedOfferWithoutExchange
        }
    }
}

export const getAllOfferWithoutExchangeAction = new GetAllOfferWithoutExchangeAction()